
import { defineStore } from "pinia";
import { ref, reactive } from "vue";
import api from "@/services/api";
import { toast } from "vue3-toastify";
import { useRouter } from "vue-router";

import { useAuthStore } from "@/stores/authenticate"; // Login state access

import Swal from "sweetalert2";


export const useCartStore = defineStore("cart", () => {
  const studenttoken = ref(localStorage.getItem("studenttoken") || null);
  const cartItems = ref([]);
    const router = useRouter();

  const authStore = useAuthStore(); // 🔹 Access user store

  /**
   * Initialize guest token if no user is logged in
   */
  const initGuestToken = async () => {
    if (authStore.user?.id) {
      // ✅ User is logged in, do NOT create guest token
      return;
    }

    if (!studenttoken.value) {
      try {
        const res = await api.post("/guest-token");
         if (res.data.success) {
          studenttoken.value = res.data.user_token;
         localStorage.setItem("studenttoken", studenttoken.value);
        }
      } catch (err) {
        console.error("Error generating guest token:", err);
      }
    }
  };

  /**
   * Add session to cart
   */
//   const addToCart = async (session) => {
//     if (!session.quantity || session.quantity < 1) {
//       toast.error("Please select at least 1 quantity before adding to cart");
//       return;
//     }

//     const user = reactive(authStore.user || {}); // ✅ Logged-in user info

//     const payload = {
//       session_id: session.id,
//       studenttoken: studenttoken.value,
//       student_id: user.id || null, // null for guest
//       quantity: session.quantity,
//       perprice: session.sprice,
//       course_id: session.course_id,
//       totalprice: session.sprice * session.quantity,
//     };

//     try {
//       const res = await api.post("/cart/add", payload);
//       if (res.data.success) {
//         toast.success("Added to Cart Successfully!");
//         session.quantity = null; // Reset quantity
//         await fetchCart();

//          // ✅ Wait a moment so toast is visible, then redirect
//       setTimeout(() => {
//         router.push("/courses/cart");
//       }, 1000);
//       }
//     } catch (err) {
//       console.error("Error adding to cart:", err);
//     }
//   };



const addToCart = async (session, sponsorCode = null) => {
  if (!session.quantity || session.quantity < 1) {
    toast.error("Please select at least 1 quantity before adding to cart");
    return;
  }

  const user = reactive(authStore.user || {});

  const payload = {
    session_id: session.id,
    studenttoken: studenttoken.value,
    student_id: user.id || null,
    quantity: session.quantity,
    perprice: session.sprice,
    course_id: session.course_id,
    totalprice: session.sprice * session.quantity,
    sponsor_code: sponsorCode || null,
  };

  try {
    const res = await api.post("/cart/add", payload);

    if (res.data.success) {
      // Sponsor code applied
      if (res.data.sponsor_applied) {
        await Swal.fire({
          title: "Sponsor Code Applied!",
          html: `Your <b>${res.data.free_tickets}</b> ticket(s) are <b>FREE</b> thanks to the sponsor code!`,
          icon: "success",
          confirmButtonText: "OK"
        });
        session.quantity = null;
        await fetchCart();
        router.push("/courses/cart");
        return;
      }

      const deal = res.data.deal_applied;

      // Deal applied
      if (deal) {
        await Swal.fire({
          title: "Deal Applied!",
          html: `
            <b>${deal.type}</b><br>
            You received <b>${deal.free_given}</b> FREE ticket(s)!
          `,
          icon: "success",
          confirmButtonText: "OK"
        });
        session.quantity = null;
        await fetchCart();
        router.push("/courses/cart");
        return;
      }

      // Normal
      toast.success("Added to Cart Successfully!");
      session.quantity = null;
      await fetchCart();

      setTimeout(() => {
        router.push("/courses/cart");
      }, 700);
    }
  } catch (err) {
    console.error("Error adding to cart:", err);
  }
};




  /**
   * Fetch cart items
   */
  const fetchCart = async () => {
    const user = reactive(authStore.user || {}); // ✅ Logged-in user info

    try {
      let res;
      if (user?.id) {
        // ✅ Logged-in user
        res = await api.get(`/cart/user/${user.id}`);
        //    if (res.data.success) {
        //   studenttoken.value = res.data.data[0].studenttoken;
        //  localStorage.setItem("studenttoken", studenttoken.value);
        // }

      } else if (studenttoken.value) {
        // ✅ Guest user
        res = await api.get(`/cart/${studenttoken.value}`);
      } else {
        cartItems.value = [];
        return;
      }

      if (res.data.success) {
        cartItems.value = res.data.data;
      }
    } catch (err) {
      console.error("Error fetching cart:", err);
    }
  };

  /**
   * Merge guest cart into logged-in user's cart
   */
  const mergeGuestCart = async () => {
    const user = authStore.user;
    if (!user?.id || !studenttoken.value) return;

    try {
      await api.post("/cart/merge", {
        guest_token: studenttoken.value,
        user_id: user.id,
      });

      // ✅ After merge, clear guest token
      studenttoken.value = null;
      localStorage.removeItem("studenttoken");

      // ✅ Fetch merged cart
      await fetchCart();
    } catch (err) {
      console.error("Error merging guest cart:", err);
    }
  };

  /**
   * Remove single cart item
   */
  const removeItem = async (id) => {
    try {
      await api.delete(`/cart/remove/${id}/${studenttoken.value}`);
      await fetchCart();
    } catch (err) {
      console.error("Error removing cart item:", err);
    }
  };

  /**
   * Clear cart
   */
  const clearCart = async () => {
    try {
      await api.delete(`/cart/clear/${studenttoken.value}`);
      await fetchCart();
    } catch (err) {
      console.error("Error clearing cart:", err);
    }
  };


  /**
 * Reset cart state (without calling API)
 */
const resetCart = () => {
  studenttoken.value = null;
  cartItems.value = [];
  localStorage.removeItem("studenttoken");
};


  /**
   * Cart count
   */
  const cartCount = () =>
    cartItems.value.reduce((sum, item) => sum + item.quantity, 0);

  return {
    studenttoken,
    cartItems,
    initGuestToken,
    addToCart,
    fetchCart,
    mergeGuestCart,
    removeItem,
    clearCart,
    cartCount,
     resetCart,
  };
});
